module.exports = ".mainContainer {\n  height: 85vh;\n  width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/molecules/alg-container-components/alg-container-components.component.scss
// module id = ./src/app/components/molecules/alg-container-components/alg-container-components.component.scss
// module chunks = main